import {mapGetters} from 'vuex';

const FocusMixin = {
  computed: {
    ...mapGetters({
      focus: 'getFocus'
    })
  },
  watch: {
    focus() {
      this.$refs.search.focus();
    }
  }
};
export default FocusMixin;
